export default "__VITE_ASSET__E11yXNmB__"